/*
 * premierstreets
 * version 4.5
 * http://www.premierstreets.com
 *
 * Copyright (c) 2021 premier streets
 * Author premier streets <support@premierstreets.com>
 * Licensed under the MIT license.
 */
import { Component, OnInit, Input, ViewChild, Inject, PLATFORM_ID, HostListener, OnChanges, } from '@angular/core';
import { SidenavMenuService } from './sidenav-menu.service';
import { Router } from '@angular/router';
// import { Title } from '@angular/platform-browser';
import { ListsSandbox } from '../../../../core/lists/lists.sandbox';
import { MatMenuTrigger } from '@angular/material/menu';
import { CommonSandbox } from '../../../../core/common/common.sandbox';
import { environment } from '../../../../environments/environment';
import { isPlatformBrowser } from '@angular/common';
import { ProductCompareSandbox } from '../../../../core/product-compare/product-compare.sandbox';
import { ProductControlSandbox } from '../../../../core/product-control/product-control.sandbox';
import { TemplateService } from '../../../../core/template/template.service';
import { CommonService } from '../../../../core/common/common.service';
import { Subscription } from 'rxjs/internal/Subscription';
import { makeStateKey, Title, TransferState } from '@angular/platform-browser';
import { ListsService } from '../../../../core/lists/lists.service';
const STATE_KEY_VENDOR_DETAIL = makeStateKey('vendorDetail');

@Component({
  selector: 'app-sidenav-menu',
  templateUrl: './sidenav-menu.component.html',
  styleUrls: ['./sidenav-menu.component.scss'],
  providers: [SidenavMenuService]
})
export class SidenavMenuComponent implements OnInit, OnChanges {

  @Input() menuItems: any;
  @Input() menuParentId;
  @Input() initial = true;
  @ViewChild(MatMenuTrigger) trigger: MatMenuTrigger;
  public parentMenu: Array<any>;
  public searchValue: any = '';
  public imagePath: any;

  public activeSlug: any;
  public index: number;
  public hover: any;
  public categoryId: string;
  public marketplaces = [];
  private subscriptions: Array<Subscription> = [];
  public imageUrl: any;

  public showSearch = false;
  public productSearch: any;
  product: any = '';
  productvalue: any;
  slug: any;
  dummyText: any = '';
  public vendors = [];
  public vendorDetail = null;
  public referSetting = null;

  public currentUser = null;
  public enableHomeBrowse: string = '1';

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    public sidenavMenuService: SidenavMenuService,
    public listService: ListsService,
    public commonSandbox: CommonSandbox,
    public router: Router,
    public listSandbox: ListsSandbox,
    public compareSandbox: ProductCompareSandbox,
    public productControl: ProductControlSandbox,
    private templateService: TemplateService,
    public commonService: CommonService,
    private state: TransferState,
    private titleService: Title) { }



  @HostListener('document:click', ['$event']) onDocumentClick(event) {
    // this.product = '';
    this.dummyText = '';
    this.showSearch = false;
    this.sidenavMenuService.toggleMenuItem('0');
  }

  // seacrh the data in the product list
  public search(data) {
    // this.product = '';
    this.product = data.name;
    this.dummyText = '';
    // this.showSearch = true;
    // this.productvalue=this.productSearch;
    this.slug = data.productSlug;
    this.router.navigate(['/products/productdetails/' + this.slug]);
    this.showSearch = false;
  }

  public goToVendor(data) {
    this.router.navigate(['/vendor-detail/detail/', data.vendorPrefixId], { queryParams: { vendorId: data.vendorId } });
  }


  public searchData() {
    // this.searchValSue = this.product;
    const params: any = {};
    params.keyword = this.product;
    this.dummyText = this.product;
    if (params.keyword) {
      this.listSandbox.getProductsearch(params);
      this.listSandbox.getProductSearch$.subscribe(data => {

      });
      this.listSandbox.getVendorSearch$.subscribe(data => {
        this.vendors = data;
      })
    }

  }


  ngOnInit() {
    this.templateService.getMarketplaces().toPromise().then((response) => {
      this.marketplaces = response.data;
    })


    if (isPlatformBrowser(this.platformId)) {
			this.currentUser = JSON.parse(localStorage.getItem('storeUser'));
		}

    this.imageUrl = environment.imageUrl;
    this.listService.getsettings().toPromise().then(res => {
      console.log(res.data);
      this.referSetting = res.data[0].referSetting;
    }
    )

    this.imagePath = environment.imageUrl;
    let vendorDetail = this.state.get(STATE_KEY_VENDOR_DETAIL, <any>null);

    if (vendorDetail !== null) {
      this.commonSandbox.setVendorDetail(vendorDetail);
    } else {
      this.commonService.getVendorDetail().toPromise().then((response: any) => {
        this.commonSandbox.setVendorDetail(response.vendor);
        this.state.set(STATE_KEY_VENDOR_DETAIL, response.vendor);
      });
    }


    this.subscriptions.push(this.commonSandbox.vendorDetail$.subscribe((vendor: any) => {
      if (vendor) {

        this.vendorDetail = vendor;
      }
    }));

 
    this.commonService.getSiteSetting().toPromise().then((response: any) => {
      this.enableHomeBrowse = response.data.enableHomeBrowse;
  });

  }

  

  ngOnChanges() {
    const menuItems = [...this.menuItems];
    menuItems.unshift({
      name: "View All",
      categoryId: 0,
      categorySlug: "All"
    });
    this.menuItems = menuItems;
  }

  setTitle(title) {
    if (title === 'All Products') {
      this.titleService.setTitle('All Products');
      this.activeSlug = 'All';

    } else if (title === 'Blogs') {
      this.titleService.setTitle(title);
      this.activeSlug = 'Blogs';
    } else if (title === 'Contacts') {
      this.titleService.setTitle(title);
      this.activeSlug = 'Contacts';
    } else if (title === 'Home') {
      this.titleService.setTitle(title);
      this.activeSlug = 'Home';
    } else if (title === 'Service') {
      this.activeSlug = 'Service';
    } else if (title === 'Refer a Friend') {
      this.titleService.setTitle(title);
      this.activeSlug = 'Refer a Friend';
    }
  }

  setMainTitle(index, category) {
    this.activeSlug = category.categorySlug;
    this.openMegaMenu();
    if (this.menuItems && this.menuItems[index] && this.menuItems[index].children && this.menuItems[index].children.length > 0) {
      this.index = index;
      this.categoryId = category.categoryId;
    } else {
      return;
    }
  }

  openMegaMenu() {

    const pane = document.getElementsByClassName('cdk-overlay-pane');
    [].forEach.call(pane, function (el) {
      if (el.children.length > 0) {
        if (el.children[0].classList.contains('mega-menu')) {
          el.classList.add('mega-menu-pane');
        }
      }
    });

    const overlay = document.getElementsByClassName(' cdk-overlay-connected-position-bounding-box');
    [].forEach.call(overlay, function (el) {
      if (el.children[0].classList.contains('mega-menu-pane')) {
        el.classList.add('mega-overlay');
      }
    });


  }

  signOut() {
    this.commonSandbox.customerLogOut();
    if (isPlatformBrowser(this.platformId)) {
      localStorage.removeItem('storeUser');
      localStorage.removeItem('storeUserToken');
      localStorage.removeItem('compareId');
      localStorage.clear();
    }
    this.compareSandbox.clearCompare([]);
    this.commonSandbox.doSignout();
    this.productControl.clearCart();
    this.router.navigate(['/auth']);
  }


  onClick(menuId) {
    this.sidenavMenuService.toggleMenuItem(menuId);
  }



  //-----------When Enter To Search Product-----------//
  onEnter() {
    const params: any = {};
    params.keyword = this.product;
    if (this.product) {
      this.router.navigate([
        'products'
      ], {
        queryParams: {
          keyword: this.product
        }
      })
    }
  }
  //-----------End Enter To Search Product-----------//


  searchDataViewAll() {

    if (this.product) {
      this.router.navigate([
        'products'
      ], {
        queryParams: {
          keyword: this.product
        }
      })
    }

  }
}
